// Requests from a previous browser session cannot still be in flight.
// Revalidate permissions on startup instead of restoring a terminal or pending flag.
export function rehydratePermissions(state) {
  if (!state?.permissions) return state;
  return {
    ...state,
    permissions: {
      ...state.permissions,
      userPermissionsStatus: 'idle',
      userPermissionsError: null,
      templatesStatus: state.permissions.templatesStatus === 'loading' ? 'idle' : state.permissions.templatesStatus,
      savingPermissions: false,
      savingTemplate: false,
      computedPermissions: {},
    },
  };
}
